/** @module EngineeringChange/AggregateSpecsMixin */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/comm",
	"csi/_base/underscore",
	"csi/xml"
], function(declare,lang,comm,_,xml) {

	const LATEST_APPROVED = "AllowedState:LatestApproved";
	const PRODUCTION_APPROVED = "AllowedState:ProductionApproved";

	return declare(null, {

		/**
		 * @override
		 * Add aggregate test
		 */
		getFormData: function() {
			let fd = this.inherited(arguments);
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregate);
			return fd;
		},

		/**
		 * Return true if a Spec is not in the affected Specs list
		 * @param {Context} ctx
		 * @param {FormData} fd
		 * @return {boolean}
		 */
		_canAggregate: function(ctx, fd) {
			let affectedItemNode = this.m_urlNode && ctx.cache.getNode(this.m_urlNode);
			if (!affectedItemNode || affectedItemNode.$Type != "AffectedItem")
				affectedItemNode = this.m_urlParent && ctx.cache.getNode(this.m_urlParent);
			if (!affectedItemNode || affectedItemNode.$Type != "AffectedItem")
				affectedItemNode = ctx.cache.getNode(fd.getFieldValue("AffectedItems"));
			if (!affectedItemNode || affectedItemNode.$Type != "AffectedItem")
				return true;

			const ecNode = ctx.cache.getNode(affectedItemNode.__Parent__);
			const allowedState = ecNode && ecNode.AllowedRevisionState;
			const specNode = ctx.getNode();
			const hasAllowedRev = specNode && _.find(ctx.cache.getNodes(specNode.Revisions), function(rev) {
				if (allowedState == LATEST_APPROVED || allowedState == PRODUCTION_APPROVED && !xml.isValidURL(rev.Phase)) {
					return (rev.State == "Revision.State:APPROVED");
				} else if (allowedState == PRODUCTION_APPROVED && xml.isValidURL(rev.Phase)) {
					return (rev.State == "Revision.State:APPROVED" && rev.Phase == "centric://REFLECTION/INSTANCE/_CS_Phase/Production");
				} else {
					return true;
				}
			});
			const affectedSpec = affectedItemNode && _.find(ctx.cache.getNodes(affectedItemNode.AffectedSpecs), function(affectedSpec) {
				const affectedSpecRev = affectedSpec && ctx.cache.getNode(affectedSpec.CurrentRevision);
				const affectedSpecRevState = affectedSpecRev && affectedSpecRev.State;
				return (ctx.getNodeURL() == affectedSpec.Spec) && !(affectedSpecRevState == "Revision.State:CLOSED" || affectedSpecRevState == "Revision.State:ABANDONED") ;
			});
			return !affectedSpec && hasAllowedRev;
		},

		/**
		 * @override
		 * When adding a shared section, a ValuesByXML query is sent to the server right after creating the new nodes; if the
		 * query accelerator is being used, it may not have the new nodes yet, so disable it temporarily
		 */
		postProcessSuccess: function() {
			comm.bypassQueryAccelerator();
			return this.inherited(arguments);
		}
	});
});